var already_submitted = false;

jQuery(document).ready(function() {

    $("#register").validate({
        ignore: [],
        focusInvalid: false,
        onfocusout: false,
        onkeyup: false,
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
                return;
            var elem = validator.errorList[0].element.id;
            console.log(elem);
            if (elem.indexOf("country") > -1) {
                $(window).scrollTo(".country-dropdown", 200, {
                    easing: 'easeOutQuart',
                    offset: -160,
                    queue: false,
                    onAfter: function() {
                        $("#" + elem).focus();
                    }
                });

            }else{
                $(window).scrollTo("#" + elem, 200, {
                    easing: 'easeOutQuart',
                    offset: -160,
                    queue: false,
                    onAfter: function() {
                        $("#" + elem).focus();
                    }
                });

            }

        },

        rules: {
            lastname: {
                required: true,
                minlength: 2
            },
            firstname: {
                required: true,
                minlength: 2
            },
            /*email: {
                required: true,
                email: true,
                pattern: '.+@cmpc\\.com\\.ar|.+@tissue\\.cmpc\\.cl|.+@protisa\\.com\\.pe|.+@ipusa\\.com\\.uy|.+@tissue\\.cmpc\\.cl|.+@cmpc\\.com\\.ec|.+@tissue\\.cmpc\\.cl|.+@cmpc\\.co|.+@cmpc\\.com\\.br|.+@cmpc\\.com\\.mx'

            },*/
            email: {
                required: true,
                email: true
            },
            country: {
                required: true
            },
            documento: {
                required: true,
                digits: true,
                maxlength: 11,
                minlength: 8
            },
            password: {
                required: true,
                minlength: 6
            },
            confirm_password: {
                equalTo: "#password",
                minlength: 6
            },
            'g-recaptcha-response': {
                recaptcha: true
            }
        },
        messages: {
            confirm_password: {
                equalTo: lang == "es" ? "Las contraseñas deben ser iguales" : "Senha e confirmação não coincidem",

            },
            email: {
                pattern: lang == "es" ? "El dominio del email debe pertencer a CMPC" : "o domínio de e-mail deve pertencer a CMPC",

            }
        },
        showErrors: function(errorMap, errorList) {
            blnValidated_at_least_once = true;
            $.each(this.successList, function(index, value) {

                var _popover = $(value).popover({
                    trigger: 'manual',
                    placement: 'top',
                    content: value.message,
                    container: '.form-group',
                    html: true,
                    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><div class="popover-content"></div></div>'
                });

                $(value).popover('hide');
            });
            var x_count = 0;
            $.each(errorList, function(index, value) {

                if (x_count > 0) {

                } else {
                    x_count++;

                    if (value.element.id.indexOf("country") > -1) {

                        var _popover = $(".country-dropdown").popover({
                            trigger: 'manual',
                            placement: 'top',
                            content: '',
                            container: 'body',
                            html: true,
                            template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><div class="popover-content"></div></div>'
                        });

                        $(".country-dropdown").attr('data-content', value.message);

                        _popover.popover('show');
                        setTimeout(function() {
                            $(".country-dropdown").popover('hide');
                        }, 3000);

                    } else {

                        var _popover = $(value.element).popover({
                            trigger: 'manual',
                            placement: 'top',
                            content: '',
                            container: 'body',
                            html: true,
                            template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><div class="popover-content"></div></div>'
                        });

                        $(value.element).attr('data-content', value.message);

                        _popover.popover('show');

                        setTimeout(function() {
                            $(value.element).popover('hide');
                        }, 3000);

                    }
                }
            });
        },
        submitHandler: function(form) {
            if (!window.already_submitted) {
                window.already_submitted = true;
                //$(".lltawfegrdewc").val($.cookie('SESS_llsudjwioweew'));
                form.method = "POST";
                form.action = lang_url + "/proc";
                form.submit();
            }
        }
    });


    $.validator.addMethod("recaptcha", function(value, element, param) {
        return (grecaptcha.getResponse() != '');
    }, "Debe validar el reCAPTCHA para continuar.");

    $.validator.addMethod("loginRegex", function(value, element) {
        return this.optional(element) || /^[a-z0-9\\-]+$/i.test(value);
    }, "Username must contain only letters, numbers, or dashes.");


    $("#btn-submit").click(function(e) {
        e.preventDefault();
        $("#btn-submit").submit();
    });

    if ($("html").hasClass("ie8")) {} else {
        if (!window.addEventListener) {
            window.attachEvent("onorientationchange", doOrientationChange);
        } else {
            window.addEventListener("onorientationchange", doOrientationChange);
        }
        //window.xhandleResize();
    }

    $('select#country').change(function () {
        $('input#documento').rules('remove');
        if( $(this).val() == 'pe' ){
           $('#documento').rules('add', {
               required: true,
               loginRegex: true,
               maxlength: 11,
               minlength: 8
           });
       }else{
           $('#documento').rules('add', {
               required: true,
               digits: true,
               maxlength: 11,
               minlength: 8
           });
       }
    });


});

var xhandleResize = function() {
    $(window).one("resize", function() {
        if (!Modernizr.touch) {
            $('input[type=text],input[type=password],input[type=checkbox],select').each(function() {
                if ($(this).attr("id") == "confirm") {
                    var offset = $(this).offset();
                    var ol = offset.left - 59;
                    var ot = offset.top + 13;
                    $(this).parent('.checkbox').find('.tooltip').css({
                        'left': ol + 'px',
                        'top': ot + 'px'
                    });
                } else {
                    $(this).blur();
                }
            });
        }
        setTimeout("xhandleResize()", 200);
    });
}
var x_reposition = function() {
    $('input[type=text],input[type=password],input[type=checkbox],select,textarea').find(":visible").each(function() {
        $('input[type=text],input[type=password],input[type=checkbox],select,textarea').find(":visible").each(function() {
            if ($(this).attr("id") == "confirm") {
                var offset = $(this).offset();
                var ol = offset.left - 59;
                var ot = offset.top + 13;
                $(this).parent('.checkbox').find('.tooltip').css({
                    'left': ol + 'px',
                    'top': ot + 'px'
                });
            } else {
                $(this).blur();
            }
        });
    });
};

function doOrientationChange() {
    x_reposition();
}
;